var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 26,
    rx: 5,
    fill: "#335D87"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10657_105029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 3,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10657_105029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2907 13.7832V16.4915C19.2907 16.645 19.3422 16.7736 19.4452 16.8774C19.5483 16.9813 19.6759 17.0332 19.8282 17.0332C19.9805 17.0332 20.1096 16.9813 20.2153 16.8774C20.3211 16.7736 20.374 16.645 20.374 16.4915V13.7832H23.0823C23.2358 13.7832 23.3644 13.7316 23.4683 13.6286C23.5721 13.5256 23.624 13.3979 23.624 13.2456C23.624 13.0933 23.5721 12.9643 23.4683 12.8585C23.3644 12.7528 23.2358 12.6999 23.0823 12.6999H20.374V9.99152C20.374 9.83804 20.3225 9.70941 20.2194 9.6056C20.1164 9.50178 19.9887 9.44987 19.8364 9.44987C19.6841 9.44987 19.5551 9.50178 19.4493 9.6056C19.3436 9.70941 19.2907 9.83804 19.2907 9.99152V12.6999H16.5823C16.4289 12.6999 16.3002 12.7514 16.1964 12.8544C16.0926 12.9574 16.0407 13.0851 16.0407 13.2374C16.0407 13.3897 16.0926 13.5188 16.1964 13.6245C16.3002 13.7303 16.4289 13.7832 16.5823 13.7832H19.2907ZM19.8395 20.8248C18.7963 20.8248 17.8138 20.6275 16.892 20.2327C15.9702 19.838 15.1634 19.2949 14.4715 18.6034C13.7797 17.9118 13.2363 17.1057 12.8414 16.1849C12.4465 15.2641 12.249 14.2803 12.249 13.2334C12.249 12.1865 12.4464 11.2056 12.8411 10.2907C13.2358 9.3759 13.779 8.57255 14.4705 7.8807C15.162 7.18884 15.9682 6.64546 16.889 6.25056C17.8097 5.85566 18.7936 5.6582 19.8405 5.6582C20.8874 5.6582 21.8683 5.85557 22.7831 6.25029C23.698 6.64501 24.5013 7.18813 25.1931 7.87966C25.885 8.5712 26.4284 9.37574 26.8233 10.2933C27.2182 11.2108 27.4156 12.1912 27.4156 13.2344C27.4156 14.2776 27.2183 15.2601 26.8236 16.1819C26.4288 17.1037 25.8857 17.9105 25.1942 18.6023C24.5026 19.2942 23.6981 19.8376 22.7806 20.2325C21.8631 20.6274 20.8827 20.8248 19.8395 20.8248ZM19.8323 19.7415C21.6379 19.7415 23.1726 19.1096 24.4365 17.8457C25.7004 16.5818 26.3323 15.0471 26.3323 13.2415C26.3323 11.436 25.7004 9.90124 24.4365 8.63735C23.1726 7.37346 21.6379 6.74152 19.8323 6.74152C18.0268 6.74152 16.4921 7.37346 15.2282 8.63735C13.9643 9.90124 13.3323 11.436 13.3323 13.2415C13.3323 15.0471 13.9643 16.5818 15.2282 17.8457C16.4921 19.1096 18.0268 19.7415 19.8323 19.7415Z",
    fill: "#F4F4F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.03bb5fa4109b6d66bbe16c36f4c0bc40.svg";
export { ForwardRef as ReactComponent };